// import React, {useEffect, useState} from "react";
// import {connect} from "react-redux";
// import Modal from "../../../general/modal";
// import {
//   isHideModalDataSelector,
//   isShowModalDataSelector,
//   modalDataSelector,
//   modalNameSelector
// } from "../../../../../store/selector/general";
// import {general} from "../../../../../store/action";
// import {TPrescriptionFields} from "../../../../../types/prescription";
// import VideoCall from "../../../../pages/videoCall/videoCall";
//
// type VideoCallOverlayProps = {
//   modalData: any;
//   modalName: string;
//   isShowModalData: boolean;
//   handleHideModal: any;
//   handleResetModal: any;
//   handleShowModal: any;
// }
//
// type ModalInfoProps = {
//   id: string;
//   visitId: string;
//   patientData?: any;
//   updateFloatingDiv: any
// }
//
// const VideoCallOverlay = ({
//  modalData,
//  modalName,
//  isShowModalData,
//  handleHideModal,
//  handleResetModal,
//  handleShowModal,
// }: VideoCallOverlayProps) => {
//   const [showState, setShowState] = useState(false);
//   const [modalInfo, setModalInfo] = useState<ModalInfoProps>({
//     id: '',
//     visitId: '',
//     patientData: '',
//     updateFloatingDiv: null
//   });
//
//   useEffect(() => {
//     if (
//       isShowModalData &&
//       modalName === 'videoCallOverlay'
//     ) {
//       setShowState(true);
//       setModalInfo(modalData);
//       handleResetModal();
//     }
//   }, [modalData, modalName])
//
//
//   const handleSetShowModal = () => {
//     setShowState(false);
//     handleHideModal();
//   }
//
//   return (
//     <Modal
//       setShow={handleSetShowModal}
//       showState={showState}
//       noCloseBtn={true}
//       fullscreen={true}
//       className="overflow-hidden vh-100 h-100"
//       bodyClassName="overflow-hidden vh-100 h-100 p-0"
//     >
//       <VideoCall handleSetShowModal={handleSetShowModal} updateFloatingDiv={modalInfo?.updateFloatingDiv?.updateFloatingDiv}/>
//     </Modal>
//   );
// };
//
// const mapStateToProps = (state: any) => ({
//   modalData: modalDataSelector(state),
//   modalName: modalNameSelector(state),
//   isShowModalData: isShowModalDataSelector(state),
//   isHideModalData: isHideModalDataSelector(state),
// });
//
// const mapDispatchToProps = (dispatch: any) => ({
//   handleHideModal: () => dispatch(general.handleHideModal()),
//   handleResetModal: () => dispatch(general.handleResetModal()),
//   handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
// });
//
// export default connect(mapStateToProps, mapDispatchToProps)(VideoCallOverlay);


// Modal.js
import VideoCall from "../../../../pages/videoCall/videoCall";
import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
  setIsInVideoCall, setLocalCamStatus,
  setLocalMicStatus,
  setVideoCallOpenPiP,
  videoCall
} from "../../../../../store/slice/videoCall"; // Import Bootstrap CSS

type VideoCallOverlayProps = {
  isVisible: boolean
  onClose: () => void;
  updateFloatingDiv: any;
}

const VideoCallOverlay = ({
  isVisible,
  onClose,
  updateFloatingDiv
}: VideoCallOverlayProps) => {

  const id = useSelector((state: any) => state.general.videoCallReducer.value); // Access the ID from the Redux store
  const videoCallOpenPiP = useSelector((state: any) => state.general.videoCallReducer.videoCallOpenPiP); // Access the ID from the Redux store
  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.key === 'Escape' && isVisible) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isVisible]);

  const setVisitIdToZero = () => {
    dispatch(videoCall(0));
    dispatch(setVideoCallOpenPiP(false));
    dispatch(setIsInVideoCall(false));
  }

  const setVideoCallId = (callId: number, openPiP: boolean) => {
    if(callId !== id) {
      dispatch(videoCall(callId));
      dispatch(setVideoCallOpenPiP(openPiP));
    }
  }

  const isInVideoCall = () => {
    dispatch(setIsInVideoCall(true));
  }

  const setLocalMic = (status: boolean) => {
    dispatch(setLocalMicStatus(status));
  }

  const setLocalCam = (status: boolean) => {
    dispatch(setLocalCamStatus(status));
  }

  return (
    <div className={`modal fade ${isVisible ? 'show' : 'd-none'}`} tabIndex={-1}
         style={{ display: isVisible ? 'block' : 'none' }}
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="width-full height-screen-100 overflow-hidden">
            <VideoCall
              isVisible={isVisible}
              handleSetShowModal={onClose}
              updateFloatingDiv={updateFloatingDiv}
              currentCallId={id}
              videoCallOpenPiP={videoCallOpenPiP}
              setVisitIdToZero={setVisitIdToZero}
              setVideoCallId={setVideoCallId}
              isInVideoCall={isInVideoCall}
              setLocalCam={setLocalCam}
              setLocalMic={setLocalMic}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoCallOverlay;
